import React, { useState, useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import SiteHeader from './SiteHeader';
import SiteFooter from './SiteFooter';
import CartDrawer from './CartDrawer';
import CustomerAuth from '../CustomerAuth';

const SiteLayout = () => {
  const [authOpen, setAuthOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return (
    <div className="flex flex-col min-h-screen">
      <SiteHeader onOpenAuth={() => setAuthOpen(true)} />
      <main className="flex-grow">
        <Outlet />
      </main>
      <SiteFooter />
      <CartDrawer />
      <CustomerAuth
        isOpen={authOpen}
        onClose={() => setAuthOpen(false)}
        onAuthSuccess={() => setAuthOpen(false)}
      />
    </div>
  );
};

export default SiteLayout;
